/**
 * Utility function to check if ReCAPTCHA should be shown based on hostname
 * @returns {boolean} True if ReCAPTCHA should be shown, false otherwise
 */
export const isReCaptchaRequired = () => {
  return (
    window.location.hostname === 'qa.usestarfish.com' ||
    window.location.hostname === 'app.usestarfish.com'
  );
};
